export default __webpack_public_path__ + "static/media/bgImage.1156e075.jpg";